import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {Internship} from '../../../../domain/model/education/internship/internship.model';
import {InternshipService} from '../../../../domain/model/education/internship/internship.service';
import {FileLocation, FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {AddressModel} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../domain/model/common/mappers/address-mapper.class';
import {ActivatedRoute} from '@angular/router';
import {InternshipScreensManager} from './internship-screens-manager.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import {VerificationService} from '../../../../components/verification/service/verification.service';

@Component({
    template: require('./internship-screen.component.html')
})
export class InternshipScreenComponent {

    constructor(readonly educationService: InternshipService,
                countryService: CountryService,
                readonly route: ActivatedRoute,
                readonly screensManager: InternshipScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {

        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => this.states = states.map(s => s.name));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _addressMapper = new AddressMapper();

    countries: Array<string> = [];
    states: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    attendanceDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    };
    attendanceFromMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    attendanceToMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    proofDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<Internship>({
        initialDataModel: new Internship(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.proofDocumentFileLocation = this.fileLocationFactory.create('internship', `currentUser/${this.index}`, new ProjectionInformation('proofDocument'));
            this.verificationService.setUrl('internship', undefined, `${this.index}`);
            return this.educationService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: Internship) => {
            return this.educationService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.educationService.doesCurrentUserModelEntryExist(this.index).map(r => !r)
    });

    get model(): Internship {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.address, addressModel);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/internship/internship-screen.component.ts